import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ScheduledJob } from 'app/library/scheduler/models/scheduled-job.model';
import { IEnvironment } from 'app/projects/core/src/lib/interfaces/environment.interface';
import { MAXBRAIN_ENVIRONMENT } from 'app/projects/core/src/lib/services/environment.token';
import { map } from 'rxjs/operators';
import { IScheduledJobQuery } from '../interfaces/scheduled-job.query.interface';
import { CreateScheduledJobCommand } from '../models/create-scheduled-job.command.model';

@Injectable()
export class SchedulerApiService {
    entity = 'scheduled-job';

    constructor(private _http: HttpClient, @Inject(MAXBRAIN_ENVIRONMENT) private _environment: IEnvironment) {}

    createScheduledJob(jobId: string, payload: ScheduledJob, executionTimestamp: number, context: any): Promise<ScheduledJob> {
        const data = new CreateScheduledJobCommand(payload, executionTimestamp, context);
        return this._http
            .post<IScheduledJobQuery>(`${this._environment.apiUrl}/${this.entity}/jobs/${jobId}/schedules`, data)
            .pipe(map((query) => new ScheduledJob(query)))
            .toPromise();
    }

    updateScheduledJob(scheduleId: string, payload: ScheduledJob, executionTimestamp: number, context: any): Promise<ScheduledJob> {
        const data = new CreateScheduledJobCommand(payload, executionTimestamp, context);
        return this._http
            .patch<IScheduledJobQuery>(`${this._environment.apiUrl}/${this.entity}/schedules/${scheduleId}`, data)
            .pipe(map((query) => new ScheduledJob(query)))
            .toPromise();
    }

    deleteScheduledJob(jobId: string): Promise<void> {
        return this._http.delete<any>(`${this._environment.apiUrl}/${this.entity}/schedules/${jobId}`).toPromise();
    }
}
